import React from "react";
import MenuSidebar from "./Components/MenuSidebar";
import AdminHeader from "../Admin/Components/AdminHeader";
import useAuth from "../../Hooks/useAuth";
import AdminSidebar from "../Admin/Components/AdminSidebar";
import { useSelector } from "react-redux";

const PanelWrapper: React.FC<{
  children: React.ReactNode;
  type: "user" | "admin";
}> = ({ children, type = "user" }) => {
  const { user } = useAuth();
  const { themeMode } = useSelector((state: any) => state.theme);

  return (
    <div className={`admin-page-wrapper ${themeMode}`}>
      {type === "admin" && <AdminSidebar />}
      {type === "user" && <MenuSidebar />}

      <div className="admin-page-content-wrapper">
        <AdminHeader />

        <div className="admin-page-content">{children}</div>
      </div>
    </div>
  );
};

export default PanelWrapper;
